module.exports = __webpack_public_path__ + "static/media/towerSample.1b46af54.png";